enum NivelRiesgo{
    
    Extremo = "Extremo",
    Alto = "Alto",
    Medio = "Medio",
    Bajo = "Bajo"
}

export default NivelRiesgo